;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.bpu.show')
    .controller('BpuShowController', BpuShowController)

  BpuShowController.$inject = [
    // Angular
    // Libs
    '$state',
    // Managers
    'InvoiceManager', 'OrderManager', 'ProductManager', 'QuoteManager',
    // Services
    'UtilService',
    // Const
    // Resolved
    'bpu', 'customFields', 'pagination'
  ]

  function BpuShowController (
    // Angular
    // Libs
    $state,
    // Managers
    InvoiceManager, OrderManager, ProductManager, QuoteManager,
    // Services
    UtilService,
    // Const
    // Resolved
    bpu, customFields, pagination
  ) {
    var self = this

    var bpuQuery = {
      bpu: bpu._id
    }

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        bpu: bpu,
        customFields,
        invoices: [],
        products: [],
        quotes: [],
        loading: {
          invoices: false,
          orders: false,
          products: false,
          quotes: false
        },
        invoicePagination: angular.copy(pagination),
        orderPagination: angular.copy(pagination),
        productPagination: angular.copy(pagination),
        quotePagination: angular.copy(pagination),
        // Public Method
        getInvoiceNumber: getInvoiceNumber,
        getInvoices: getInvoices,
        getProducts: getProducts,
        getOrders: getOrders,
        getQuotes: getQuotes,
        getQuoteNumber: getQuoteNumber,
        search: search
      })

      init()
    }

    function init () {
      getInvoices()
      getProducts()
      getQuotes()
      getOrders()
    }

    function getInvoices () {
      self.loading.invoices = true
      var query = InvoiceManager.query(
        {
          conditions: bpuQuery
        }
      ).paginate(self.invoicePagination.toQueryOptions())

      return InvoiceManager.post(query)
        .then(function (data) {
          self.invoices = data.data
          self.loading.invoices = false
          self.invoicePagination.totalElements = data.meta.total
        })
    }

    function getProducts () {
      self.loading.products = true
      var query = ProductManager.query(
        {
          conditions: bpuQuery,
          archived: 'both'
        }
      ).paginate(self.productPagination.toQueryOptions())
      return ProductManager.post(query, { ignoreArchived: true })
        .then(function (data) {
          self.products = data.data
          self.loading.products = false
          self.productPagination.totalElements = data.meta.total
        })
    }

    function getQuotes () {
      self.loading.quotes = true
      var query = QuoteManager.query(
        {
          conditions: bpuQuery
        }
      ).paginate(self.quotePagination.toQueryOptions())

      return QuoteManager.post(query)
        .then(function (data) {
          self.quotes = data.data
          self.loading.quotes = false
          self.quotePagination.totalElements = data.meta.total
        })
    }

    function getOrders () {
      self.loading.orders = true
      var query = OrderManager.query(
        {
          conditions: bpuQuery
        }
      ).paginate(self.orderPagination.toQueryOptions())

      return OrderManager.post(query)
        .then(function (data) {
          self.orders = data.data
          self.loading.orders = false
          self.orderPagination.totalElements = data.meta.total
        })
    }

    function getInvoiceNumber (invoice) {
      if (_.get(invoice, 'status', 'draft') === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat)
    }

    function getQuoteNumber (quote) {
      if (_.get(quote, 'status', 'draft') === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat)
    }

    function search (route) {
      $state.go(route + '.list', { linkedSearch: { bpu: self.bpu } })
    }
  }
})(window.angular, window._)
